@use '@ingka/base/_mixins.scss' as *;
@use '@ingka/variables/style.scss' as *;

.logoutButton {
  padding-block-start: $space-200;
  padding-block-end: $space-125;
  padding-inline: $space-125;
  text-decoration: underline;
}

.standalone {
  padding-inline-start: 0;
}
